import React from 'react';
import AlumniManagementPanel from './AlumniManagementPanel';

/**
 * AdminAlumni — entry point for /admin/alumni
 * Renders the full-featured AlumniManagementPanel inside AdminLayout.
 */
const AdminAlumni = () => <AlumniManagementPanel />;

export default AdminAlumni;
